export default {
  computed: {

    isHomePage() {
      return (this.$route.path === "/")
    },

    isProfilePage() {
      return this.$route.path.startsWith("/profile")
    },

    // Administração    
    isAdminPage() {
      return this.$route.path.startsWith("/admin")
    },
    isSettingsPage() {
      return this.$route.path.startsWith("/admin/settings")
    },
    isUsersPage() {
      return this.$route.path.startsWith("/admin/users")
    },
    isUserGroupsPage() {
      return this.$route.path.startsWith("/admin/user-groups")
    },         
    isNotesPage() {
      return this.$route.path.startsWith("/admin/notes")
    },    
    
    //Financeiro
    isFianncialPage() {
      return this.$route.path.startsWith("/financial")
    },
    isSuppliersPage() {
      return this.$route.path.startsWith("/financial/suppliers")
    },
    isFinancialNaturesPage() {
      return this.$route.path.startsWith("/financial/natures")
    },
    isReceivablesPage() {
      return this.$route.path.startsWith("/financial/receivables")
    },
    isPayablesPage() {
      return this.$route.path.startsWith("/financial/payables")
    },    
    isFinancialDailyCertsPage() {
      return this.$route.path.startsWith("/financial/daily-certs")
    },
    isFinancialEmployeeCertsPage() {
      return this.$route.path.startsWith("/financial/employee-certs")
    },
    isFinancialPendingCertsPage() {
      return this.$route.path.startsWith("/financial/pending-certs")
    },
    isCertAnticipationsPage() {
      return this.$route.path.startsWith("/financial/cert-anticipations")
    },
    isCustomerInvoicesPage() {
      return this.$route.path.startsWith("/financial/customer-invoices")
    },
    isEmployeeInvoicesPage() {
      return this.$route.path.startsWith("/financial/employee-invoices")
    },

    // Cadastros
    isEntriesPage() {
      return this.$route.path.startsWith("/entries")
    },    
    isCustomersPage() {
      return this.$route.path.startsWith("/entries/customers")
    },    
    isVetsPage() {
      return this.$route.path.startsWith("/entries/vets")
    },            
    isAnimalsPage() {
      return ( this.$route.path.startsWith("/entries/species") || this.$route.path.startsWith("/entries/races") || 
               this.$route.path.startsWith("/entries/owners") || this.$route.path.startsWith("/entries/animal"))
    },  
    isSpeciesPage() {
      return this.$route.path.startsWith("/entries/species")
    },    
    isRacesPage() {
      return this.$route.path.startsWith("/entries/races")
    },      
    isOwnersPage() {
      return this.$route.path.startsWith("/entries/owners")
    },      
    isAnimalsIndexPage() {
      return this.$route.path.startsWith("/entries/animals")
    },      
    isAnimalRegistrationsPage() {
      return this.$route.path.startsWith("/entries/animal-registrations")
    }, 
    isCertsPage() {
      return ( this.$route.path.startsWith("/entries/organs") || this.$route.path.startsWith("/entries/cert-templates") )
    },         
    isOrgansPage() {
      return this.$route.path.startsWith("/entries/organs")
    },         
    isCertTemplatesPage() {
      return this.$route.path.startsWith("/entries/cert-templates")
    },    
    isExamTypesPage() {
      return this.$route.path.startsWith("/entries/exam-types")
    },   
    isServicesPage() {
      return this.$route.path.startsWith("/entries/services")
    },   

    // Processos
    isProcsPage() {
      return this.$route.path.startsWith("/procs")
    },
    isExamRequestsPage() {
      return this.$route.path.startsWith("/procs/exam-requests")
    },
    isCertsPage() {
      return this.$route.path.startsWith("/procs/certs")
    },
    isCertComplementRequestsPage() {
      return this.$route.path.startsWith("/procs/cert-complement-requests")
    },
  }
}
